import { useState, useEffect } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button, Flex, Text, useColorMode } from 'theme-ui';
import { ActionModuleTab } from './ActionModuleTab';

export const ActionModule = ({ selectedHighlight, Open, setOpen, actionObject, keys, activeTab, TaskView, setShowModal, handleHighlightClick, stageName }: any) => {
  const [tabIndex, setTabIndex] = useState(activeTab);

  useEffect(() => {
    if (Open) {
      setTabIndex(activeTab);
    }
  }, [Open, activeTab]);

  const togglePopover = () => {
    setOpen(!Open);
  };

  const handleDeliverClick = () => {
    setShowModal(true);
    setOpen(!Open);
  };
  const [colorMode] = useColorMode();
  const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";
  // custom close button so we can control its color based on theme
  const closeButton = (
    <button
      type="button"
      aria-label="Close"
      onClick={togglePopover}
      style={{
        color: colorMode === 'dark' ? '#fff' : '#000',
        background: 'transparent',
        border: 'none',
        fontSize: 20,
        lineHeight: 1,
        padding: 0,
        cursor: 'pointer'
      }}
    >
      <span aria-hidden="true">&times;</span>
    </button>
  );
  return (
    <Modal isOpen={Open} scrollable toggle={togglePopover} size="xl" centered >
      {Open && (
        <>
          <ModalHeader toggle={togglePopover} close={closeButton} style={{ backgroundColor: modalHeader }}>
            <Flex sx={{ gap: "0.5rem" }}>
              {selectedHighlight?.icon && <img width={22} src={selectedHighlight?.icon} alt='icon' />}
              <Text sx={{ color: selectedHighlight?.color }}>{selectedHighlight?.name?.toUpperCase()}</Text>
            </Flex>
          </ModalHeader>

          <ModalBody className="scrollable-modal-body" style={{ backgroundColor: modalHeader }}>

            <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
              <TabList>
                <Tab>Stage</Tab>
                {TaskView?.map((item: any) => <Tab key={item?.id || item?._id}>{item?.name}</Tab>)}
              </TabList>
              <TabPanel>
                <ActionModuleTab
                  actionObject={{ ...actionObject, taskId: null }}
                  selectedHighlight={selectedHighlight}
                  keys={keys}
                  handleHighlightClick={handleHighlightClick}
                  isActive={tabIndex === 0}
                />
              </TabPanel>

              {TaskView?.map((item: any, index: number) =>
                <TabPanel key={item?.id || item?._id}>
                  <ActionModuleTab
                    actionObject={{ ...actionObject, taskId: item?.id || item?._id }}
                    selectedHighlight={selectedHighlight}
                    keys={keys}
                    handleHighlightClick={handleHighlightClick}
                    isActive={tabIndex === index + 1}
                  />
                </TabPanel>)
              }
            </Tabs>
          </ModalBody>
          <ModalFooter style={{ backgroundColor: modalHeader }}>
            {(setShowModal && tabIndex === 0) && (
              <Button className='me-2 px-4' onClick={handleDeliverClick} >
                {'Deliver'}
              </Button>
            )}
          </ModalFooter>
        </>
      )}
    </Modal >
  )
}
